import React from 'react';
import { useParams } from 'react-router-dom';

import { decodeUrlName, useSportsbookState } from '@atlas/core';
import { EmptyStateView } from '@atlas/ui';

const EmptySportView = props => {
  const { sportName } = useParams();

  const { sports } = useSportsbookState();

  if (
    sports.length &&
    sportName &&
    !sports.some(sport => sport.urlName === encodeURIComponent(decodeUrlName(sportName)))
  ) {
    return (
      <div className="category-container">
        <EmptyStateView description="sportsbook_no_events_message" title="sportsbook_no_events" />
      </div>
    );
  }

  return props.children;
};

export default EmptySportView;
